// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f5e23b7","455":"ed748a2b","977":"4750e604"}[chunkId] + ".chunk.js";
};